import React from 'react'
import styled from 'styled-components'
import { PreviousPageIcon } from '../Icon/PreviousPageIcon'
import { NextPageIcon } from '../Icon/NextPageIcon'
import { Link } from '../Link'

const ButtonGutter = '.75rem'

const StyledLink = styled(Link)`
  font-weight: bold;
  display: flex;
  align-items: center;
`

const PreviousButton = styled(StyledLink).attrs({
  children: (
    <>
      <PreviousPageIcon /> Prev
    </>
  ),
})`
  margin-right: ${ButtonGutter};
`

const NextButton = styled(StyledLink).attrs({
  children: (
    <>
      Next <NextPageIcon />
    </>
  ),
})`
  margin-left: ${ButtonGutter};
`

export { PreviousButton, NextButton }
